import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import * as R from 'ramda';
import locales from '@/i18n/locales';

const availableLocales = ['en', 'ja', 'zh', 'kr'];

i18n.use(initReactI18next).init({
  lng: 'en',
  fallbackLng: 'en',
  whitelist: availableLocales,
  ns: ['common'],
  defaultNS: 'common',
  debug: process.env.NODE_ENV === 'development',
  resources: locales,
  returnObjects: true,
});

const lookup = (propName, key) =>
  R.compose(
    collection => collection[key],
    R.fromPairs
  )(i18n.t(`selection:${propName}`));

const useFixedTranslation = (lang, namespace) => {
  const currentLang = lang === 'zh-TW' ? 'zh' : lang;
  return i18n.getFixedT(currentLang, namespace);
};

const localizePath = location => {
  const {pathname, search} = location;
  const fullReq = `${pathname}${search}`;
  const allLocales = R.join('|', availableLocales);

  return lang => R.replace(RegExp(`^(/(${allLocales}))?`), `/${lang}`, fullReq);
};

export {availableLocales, lookup, useFixedTranslation, localizePath};
export default i18n;
